(function () {
    "use strict";

    var datepickers = new WeakMap();
    var bondStatusState = null;

    function pad2(value) {
        return value.toString().padStart(2, "0");
    }

    function formatDate(date) {
        return pad2(date.getMonth() + 1) + "/" + pad2(date.getDate()) + "/" + date.getFullYear();
    }

    function parseDate(value) {
        if (!value) {
            return null;
        }

        var parts = value.split("/");
        if (parts.length !== 3) {
            return null;
        }

        var month = parseInt(parts[0], 10) - 1;
        var day = parseInt(parts[1], 10);
        var year = parseInt(parts[2], 10);
        var date = new Date(year, month, day);

        if (date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day) {
            return null;
        }

        return date;
    }

    function setDatepickerLimit(inputId, methodName, date) {
        var input = document.getElementById(inputId);
        var picker = input ? datepickers.get(input) : null;

        if (picker && typeof picker[methodName] === "function") {
            picker[methodName](date);
        }
    }

    function initializeDatepickers(root) {
        if (typeof Pikaday === "undefined") {
            return;
        }

        (root || document).querySelectorAll(".datepicker").forEach(function (input) {
            if (datepickers.has(input)) {
                return;
            }

            var picker = new Pikaday({
                field: input,
                format: "MM/DD/YYYY",
                toString: formatDate,
                parse: parseDate,
                reposition: true,
                showDaysInNextAndPreviousMonths: true,
                enableSelectionDaysInNextAndPreviousMonths: true,
                onSelect: function () {
                    input.dispatchEvent(new Event("change", { bubbles: true }));
                }
            });

            var existingDate = parseDate(input.value);
            if (existingDate) {
                picker.setDate(existingDate, true);
            }

            datepickers.set(input, picker);
        });

        SetMinOnEndDate();
        SetMaxOnStartDate();
    }

    function revertCarrierStatusSelect() {
        if (!bondStatusState || bondStatusState.confirmed) {
            return;
        }

        bondStatusState.select.value = bondStatusState.activeValue === "false" ? "true" : "false";
    }

    function getBondStatusModal() {
        var dialog = document.getElementById("BondStatusConfirmationDialog");

        if (!dialog || typeof bootstrap === "undefined") {
            return null;
        }

        return bootstrap.Modal.getOrCreateInstance(dialog);
    }

    function getFormEncodedPayload(data) {
        var payload = new URLSearchParams();

        Object.keys(data).forEach(function (key) {
            payload.append(key, data[key]);
        });

        return payload;
    }

    async function refreshCarrierLists(carrierId, bankId, isActive) {
        var responses = await Promise.all([
            axios.get("/Banks/GetActiveCarriersList", {
                params: { carrierId: carrierId, bankId: bankId, isActive: isActive }
            }),
            axios.get("/Banks/GetInActiveCarriersList", {
                params: { carrierId: carrierId, bankId: bankId, isActive: isActive }
            })
        ]);
        var activeResponse = responses[0];
        var inactiveResponse = responses[1];

        if (inactiveResponse.data !== "Error") {
            document.getElementById("divInactiveCarriers").innerHTML = inactiveResponse.data;
        }

        if (activeResponse.data !== "Error") {
            document.getElementById("divActiveCarriers").innerHTML = activeResponse.data;
        }
    }

    async function confirmBondStatusChange() {
        if (!bondStatusState || typeof axios === "undefined") {
            return;
        }

        try {
            var statusDate = document.getElementById("txtBondStatusDate").value;
            var response = await axios.post(
                "/Banks/UpdateCarrierActiveStatus",
                getFormEncodedPayload({
                    carrierId: bondStatusState.carrierId,
                    bankId: bondStatusState.bankId,
                    isActive: bondStatusState.activeValue,
                    StatusEffectiveDate: statusDate
                })
            );

            if (response.data === "Error") {
                return;
            }

            bondStatusState.confirmed = true;
            document.getElementById("lblTotalBondLiability").innerHTML = response.data;
            await refreshCarrierLists(bondStatusState.carrierId, bondStatusState.bankId, bondStatusState.activeValue);

            var modal = getBondStatusModal();
            if (modal) {
                modal.hide();
            }
        } catch (error) {
            throw error;
        }
    }

    // On calendar StartDate change: Sets minimum date on End date calendar.
    window.SetMinOnEndDate = function () {
        var startDateInput = document.getElementById("txtStartDate");
        var selectedDate = startDateInput ? parseDate(startDateInput.value) : null;

        setDatepickerLimit("txtEndDate", "setMinDate", selectedDate);
    };

    // On calendar EndDate change: Sets maximum date on Start date calendar.
    window.SetMaxOnStartDate = function () {
        var endDateInput = document.getElementById("txtEndDate");
        var selectedDate = endDateInput ? parseDate(endDateInput.value) : null;

        setDatepickerLimit("txtStartDate", "setMaxDate", selectedDate);
    };

    // [Admin] Update carrier status to Active/Inactive. Users can view only Active carriers.
    window.UpdateCarrierActiveStatus = function (activeSelect, carrierId, bankId) {
        var dateInput = document.getElementById("txtBondStatusDate");
        var warning = document.getElementById("txtWarning");
        var modal = getBondStatusModal();

        if (!dateInput || !warning || !modal) {
            return;
        }

        var activeValue = activeSelect.value;
        dateInput.value = formatDate(new Date());
        warning.textContent = activeValue === "false"
            ? "Would you like to cancel the bond?"
            : "Would you like to Active the bond?";

        bondStatusState = {
            select: activeSelect,
            carrierId: carrierId,
            bankId: bankId,
            activeValue: activeValue,
            confirmed: false
        };

        initializeDatepickers(document.getElementById("BondStatusConfirmationDialog"));
        modal.show();
    };

    document.addEventListener("DOMContentLoaded", function () {
        initializeDatepickers(document);

        var dialog = document.getElementById("BondStatusConfirmationDialog");
        if (dialog) {
            dialog.addEventListener("hidden.bs.modal", revertCarrierStatusSelect);
        }

        var confirmButton = document.getElementById("btnBondStatusConfirm");
        if (confirmButton) {
            confirmButton.addEventListener("click", function () {
                confirmBondStatusChange().catch(function () {
                    revertCarrierStatusSelect();
                });
            });
        }
    });
})();